import { useContext } from "react";
import { notification } from "antd";
import { deleteRequest, getRequest, handleResponse, patchFormRequests, patchRequest, postFormRequest, postFormRequests, putFormRequest } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import { useMutation, useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import authAtom from "../../atoms/auth/auth.atom";



export function useGetBlogs(params, key) {
  const url = "/Blog/GetBlogs"; 
  const axios = useContext(AxiosContext);
  return useQuery(["key:get_all_Blog", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
    onSuccess: (response) => handleResponse(response),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetBlogCats(params, key) {
    const url = "/Blog/GetBlogCategories"; 
    const axios = useContext(AxiosContext);
    return useQuery(["key:get_all_blogCategories", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
      onSuccess: (response) => handleResponse(response),
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

export function useGetBlog(successAction) {
  const url = "/Blog/GetBlog/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetBlogByCat(successAction) {
    const url = "/Blog/GetBlogsByCategory/";
    const axios = useContext(AxiosContext);
    return useMutation((id) => getRequest(axios, url+id), {
      onSuccess: (response) => handleResponse(response, () => successAction?.()),
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

export function usePostBlogs(successAction) {
  const url = "/Blog/CreateBlog"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => postFormRequests(url, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePostBlogCat(successAction) {
    const url = "/Blog/CreateBlogCategory"; 
    const { user } = useRecoilValue(authAtom)
    return useMutation((payload) => postFormRequest(url, payload, user?.token), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

export function usePutBlogCat(successAction) {
  const url = "/Blog/EditBlogCategory/";
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => putFormRequest(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useDeleteBlog(successAction) {
  const url = `/Blog/DeleteBlog/`;
  const axios = useContext(AxiosContext);
  return useMutation((id) => deleteRequest(axios, url+id), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useDeleteBlogCat(successAction) {
    const url = `/Blog/DeleteBlogCategory/`;
    const axios = useContext(AxiosContext);
    return useMutation((id) => deleteRequest(axios, url+id), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

export function usePatchBlogx(successAction) {
  const url = `/Blog/EditBlog/`; 
  const axios = useContext(AxiosContext);
  return useMutation((payload) => patchRequest(axios, url+payload?.id, payload), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePatchBlog(successAction) {
  const url = "/Blog/EditBlog/"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => patchFormRequests(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}